import React from "react";
import { Capitalize } from "../../../utils/Capitalize";
import Ttable from "../../TotalExpenseReport/UserStyledTable";

interface IReport {
  data: any;
  reportType?: string;
  companyId?: any;
  companyName?: any;
}

const Report: React.FC<IReport> = (props) => {
  if (props.data.length === 0) {
    return (
      <>
        <br />

        <div
          style={{
            borderTop: "1.5px solid red",
            textAlign: "center",
            color: "red",
            fontSize: "16px",
            marginTop: "10px",
            paddingTop: "5px",
          }}
        >
          No data found !...
        </div>
      </>
    );
  }

  return (
    <Ttable
      reportType={props.reportType}
      companyName={props.companyName}
      companyId={props.companyId}
      tableTitle="Empolyee Expense Report"
      tableHeadList={["Name", "Email", "DFS ID ", "Role", "Expense"]}
    >
      {props.data &&
        props.data.map((item: any, index: number) => {
          if (item?.expense === 0) {
            return null;
          }

          return (
            <tr key={index}>
              <td>{item?.name}</td>
              <td>{item?.email}</td>
              <td>{item?.dfs_id}</td>
              <td>{Capitalize(item?.role)}</td>
              <td>{item?.expense.toFixed(2)}</td>
            </tr>
          );
        })}
    </Ttable>
  );
};

export default Report;